var _style, _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectUnrealEditV02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21,21H3c-1.6,0-3-1.3-3-3V6c0-1.6,1.3-3,3-3H21c1.6,0,3,1.3,3,3V18C24,19.7,22.7,21,21,21z M3,5 C2.4,5,2,5.4,2,6V18c0,0.5,0.4,1,1,1H21c0.5,0,1-0.4,1-1V6c0-0.5-0.4-1-1-1H3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.8,15.3c-0.1,0-0.3,0-0.4-0.1C9.2,15,9,14.7,9,14.4V9.1c0-0.3,0.2-0.6,0.4-0.7c0.3-0.1,0.6-0.1,0.8,0L15,11 c0.3,0.1,0.4,0.4,0.4,0.7c0,0.3-0.2,0.6-0.4,0.7l-4.7,2.7C10.1,15.2,10,15.3,9.8,15.3z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20,6h-8l-2-2H4C2.9,4,2,4.9,2,6l0,12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V8C22,6.9,21.1,6,20,6z M10,17.1 c-0.2,0-0.3,0-0.5-0.1C9.2,16.8,9,16.5,9,16.1V9.9C9,9.5,9.2,9.2,9.5,9c0.3-0.2,0.7-0.2,1,0l5.5,3.1c0.3,0.2,0.5,0.5,0.5,0.8 c0,0.3-0.2,0.7-0.5,0.8L10.4,17C10.3,17.1,10.1,17.1,10,17.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectUnrealEditV02);
export default __webpack_public_path__ + "static/media/projectUnrealEdit_v02.d089f2e263740d308fe561f96ea9f8a7.svg";
export { ForwardRef as ReactComponent };